import FilterSection from './components/FilterSection/FilterSection';
import GridSection from './components/GridSection/GridSection';

import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import MSSalesPlanNavigator from '../components/MSPlanSalesPlanNavigator/MSSalesPlanNavigator';
import classes from './SalesPlanBulkEditScreen.module.scss';
import { useSalesPlanBulkEdit } from './useSalesPlanBulkEditScreen.logic';

const SalesPlanBulkEditScreen = () => {
  const {
    editData,
    setEditData: _setEditData,
    setEditDataCopy: _setEditDataCopy,
    handleApplyFilter,
    filterData,
    pageNumber: _pageNumber,
    setPageNumber: _setPageNumber,
    isDataLoading,
    setIsDataLoading: _setIsDataLoading,
    getForecastValue,
    GFCNotesSet,
    setGFCNotesSet: _setGFCNotesSet,
    gfcCotSellingCategoryError,
    setgfcCotSellingCategoryError: _setgfcCotSellingCategoryError,
    handleSingleSave,
    handleSaveAllEdited,
    gfcCotSellingCategorySaveLoading,
    isSaveAllLoading,
    isNotesLoading,
    notesData,
    isNoteSaving,
    getNotesData: _getNotesData,
    handleAddNote,
    hasMore,
    nextPageLoading,
    loadMore,
    toggleVisibilityForNotes,
    handleSaveInputValue,
    isSaveAllBtnEnabled,
    checkGfcCotSCisSaving,
    isNotesButtonEnabled,
    handleNoteButtonClick,
    checkIfRowHasError: _checkIfRowHasError,
    isSaveButtonEnabled,
    focussedRowForNoteAdd,
    singleSaveConfirmationModalVisibility,
    saveAllConfirmationModalVisibility,
    setSingleSaveConfirmationModalVisibility,
    setSaveAllConfirmationModalVisibility,
    focussedRowForSaving,
    handleSingleSaveButtonClick,
    handleAllSaveButtonClick,
    isRouteChangeConfirmationPopUpVisible,
    handleGoToMsPlan,
    handleMsPlanButtonClick,
    toggleVisibilityForRouteConfirmationPopUp,
    GFCEditedSet,
    isCancelConfirmationPopVisible,
    handleCancelButtonClick,
    toggleCancelConfirmationPopUpVisibility,
    handleGoToTMSViewScreen,
    setNotesData,
    isNoteEdited,
    setIsNoteEdited,
    isNoteDeleted,
    setIsNoteDeleted,
    handleCopy,
    handleEditNote,
    handleDeleteNote,
    deletingNote,
    isNoteDeleting,
    isDeleteClicked,
    setIsDeleteClicked,
    setDeletingNote,
    initialLoading,
    // New accordion-related props
    expandedRows,
    toggleRowExpansion,
    isRowExpanded,
    getActiveMarketForecastValue,
    // New concept sort prop
    handleConceptSort,
    // New sales plan type selection props
    getSelectedSalesPlanType,
    handleSalesPlanTypeChange,
    getSalesPlanValueByType: _getSalesPlanValueByType,
    shouldShowToggle,
  } = useSalesPlanBulkEdit();

  const _navigate = useNavigate();

  return (
    <div className={classes.container}>
      <MSSalesPlanNavigator
        currentScreen="salesPlan"
        msPlanClick={handleMsPlanButtonClick}
        salesPlanClick={() => {}}
      />
      {/* Filter component */}
      <FilterSection
        isDataLoading={isDataLoading}
        handleApplyFilter={handleApplyFilter}
        parentFilterPayload={filterData}
        daveToSaveIsThere={GFCEditedSet.size != 0}
      />
      {/* grid component */}
      <GridSection
        key={JSON.stringify(filterData)}
        dataLoading={isDataLoading}
        data={editData}
        initialLoading={initialLoading}
        handleCopy={handleCopy}
        getForecastValue={getForecastValue}
        handleSaveInputValue={handleSaveInputValue}
        isSaveButtonEnabled={isSaveButtonEnabled}
        isSaveAllBtnEnabled={isSaveAllBtnEnabled}
        gfcCotSCNotesErrorSet={gfcCotSellingCategoryError}
        handleSingleSave={handleSingleSaveButtonClick}
        handleSaveAllEdited={handleAllSaveButtonClick}
        checkGfcCotSCisSaving={checkGfcCotSCisSaving}
        isSaveAllLoading={isSaveAllLoading}
        isNotesButtonEnabled={isNotesButtonEnabled}
        handleNoteButtonClick={handleNoteButtonClick}
        hasMore={hasMore}
        loadMore={loadMore}
        nextPageLoading={nextPageLoading}
        filterData={filterData}
        visibility={focussedRowForNoteAdd !== null}
        handleCancel={toggleVisibilityForNotes}
        isNotesLoading={isNotesLoading}
        notesData={notesData}
        setNotesData={setNotesData}
        GFCNotesSet={GFCNotesSet}
        isNoteEdited={isNoteEdited}
        setIsNoteEdited={setIsNoteEdited}
        isNoteDeleted={isNoteDeleted}
        setIsNoteDeleted={setIsNoteDeleted}
        isNoteSaving={isNoteSaving}
        handleAddNote={handleAddNote}
        handleEditNote={handleEditNote}
        handleDeleteNote={handleDeleteNote}
        deletingNote={deletingNote}
        isNoteDeleting={isNoteDeleting}
        isDeleteClicked={isDeleteClicked}
        setIsDeleteClicked={setIsDeleteClicked}
        setDeletingNote={setDeletingNote}
        focussedRowForNoteAdd={focussedRowForNoteAdd}
        toggleVisibilityForNotes={toggleVisibilityForNotes}
        // New accordion-related props
        expandedRows={expandedRows}
        toggleRowExpansion={toggleRowExpansion}
        isRowExpanded={isRowExpanded}
        getActiveMarketForecastValue={getActiveMarketForecastValue}
        // New concept sort prop
        handleConceptSort={handleConceptSort}
        // New sales plan type selection props
        getSelectedSalesPlanType={getSelectedSalesPlanType}
        handleSalesPlanTypeChange={handleSalesPlanTypeChange}
        getSalesPlanValueByType={_getSalesPlanValueByType}
        shouldShowToggle={shouldShowToggle}
      />
      <div className={classes.btnContainer}>
        <Button className={classes.cancelBtn} onClick={handleCancelButtonClick}>
          Cancel
        </Button>
      </div>

      {/* <NotesSection
        visibility={focussedRowForNoteAdd !== null}
        handleCancel={toggleVisibilityForNotes}
        isNotesLoading={isNotesLoading}
        notesData={notesData}
        isNoteSaving={isNoteSaving}
        handleAddNote={handleAddNote}
      /> */}

      {/* single save confirmation modal */}
      {focussedRowForSaving && (
        <ConfirmationModal
          visibility={singleSaveConfirmationModalVisibility}
          modalHeading="Confirmation"
          modalContent={`Are you sure want to update the Sales Plan ?`}
          loading={checkGfcCotSCisSaving(focussedRowForSaving)}
          confirmLabel="Update"
          handleCancel={() => setSingleSaveConfirmationModalVisibility(prev => !prev)}
          handleConfirm={() => handleSingleSave()}
        />
      )}

      {/* save all confirmation modal */}
      {saveAllConfirmationModalVisibility && (
        <ConfirmationModal
          visibility={saveAllConfirmationModalVisibility}
          modalHeading="Confirmation"
          modalContent={`Are you sure want to update the Sales Plan for all edited GFCs ?`}
          loading={isSaveAllLoading}
          confirmLabel="Update All"
          handleCancel={() => setSaveAllConfirmationModalVisibility(prev => !prev)}
          handleConfirm={handleSaveAllEdited}
        />
      )}

      {/* save all confirmation modal */}
      {focussedRowForSaving !== null && singleSaveConfirmationModalVisibility && (
        <ConfirmationModal
          visibility={singleSaveConfirmationModalVisibility}
          modalHeading="Confirmation"
          modalContent={`Are you sure want to upadte the Sales Plan ? ?`}
          loading={gfcCotSellingCategorySaveLoading.has(
            `${editData[focussedRowForSaving].GFC}-${editData[focussedRowForSaving].COT}-${editData[focussedRowForSaving].SellingCategory}`
          )}
          confirmLabel="Update"
          handleCancel={() => setSingleSaveConfirmationModalVisibility(prev => !prev)}
          handleConfirm={handleSingleSave}
        />
      )}

      {/* save screen switch confirmation */}
      {isRouteChangeConfirmationPopUpVisible && (
        <ConfirmationModal
          visibility={isRouteChangeConfirmationPopUpVisible}
          modalHeading="Confirmation"
          modalContent={`You have not saved changes, are you sure you want to switch ?`}
          loading={false}
          confirmLabel="Confirm"
          handleCancel={toggleVisibilityForRouteConfirmationPopUp}
          handleConfirm={handleGoToMsPlan}
        />
      )}

      {/* save screen switch confirmation */}
      {isCancelConfirmationPopVisible && (
        <ConfirmationModal
          visibility={isCancelConfirmationPopVisible}
          modalHeading="Confirmation"
          modalContent={`You have not saved changes, are you sure you want to cancel ?`}
          loading={false}
          confirmLabel="Confirm"
          handleCancel={toggleCancelConfirmationPopUpVisibility}
          handleConfirm={handleGoToTMSViewScreen}
        />
      )}
    </div>
  );
};

export default SalesPlanBulkEditScreen;
